export const SHIPMENT_GRID_CHANGE_COLUMNS = 'SHIPMENT_GRID_CHANGE_COLUMNS';
export const SHIPMENT_GRID_CHANGE_PAGE = 'SHIPMENT_GRID_CHANGE_PAGE';
export const SHIPMENT_GRID_MANAGE_COLUMNS = 'SHIPMENT_GRID_MANAGE_COLUMNS';
export const SHIPMENT_GRID_CHANGE_ORDERBY = 'SHIPMENT_GRID_CHANGE_ORDERBY';
export const DOWNLOAD_SHIPMENT_GRID_PACKING_SLIPS = 'DOWNLOAD_SHIPMENT_GRID_PACKING_SLIPS';
export const PRINT_SHIPMENT_GRID_PACKING_SLIPS = 'PRINT_SHIPMENT_GRID_PACKING_SLIPS';
export const DIRECT_PRINT_SHIPMENT_GRID_PACKING_SLIPS = 'DIRECT_PRINT_SHIPMENT_GRID_PACKING_SLIPS';
export const DIRECT_PRINT_SHIPMENT_GRID_LABELS = 'DIRECT_PRINT_SHIPMENT_GRID_LABELS';
export const PRINT_SHIPMENT_GRID_LABELS = 'PRINT_SHIPMENT_GRID_LABELS';
export const DOWNLOAD_SHIPMENT_GRID_LABELS = 'DOWNLOAD_SHIPMENT_GRID_LABELS';
export const SHIPMENT_GRID_SHOW_SPINNER = 'SHIPMENT_GRID_SHOW_SPINNER';
export const SHIPMENT_GRID_UPDATE_CUSTOM_CONFIGURATION = 'SHIPMENT_GRID_UPDATE_CUSTOM_CONFIGURATION';
export const PATCH_AMAZON_SHIPMENT_NOTIFICATIONS = 'PATCH_AMAZON_SHIPMENT_NOTIFICATIONS';

export const shipmentGridChangeColumns = (statusViewId, filterViewId, columns) => {
  const statefulConfig = columns.map((c) => ({
    id: c.id,
    index: c.index,
    width: c.width,
    pinned: c.pinned,
    sorted: c.sorted,
  }));
  return {
    type: SHIPMENT_GRID_CHANGE_COLUMNS,
    statusViewId,
    filterViewId,
    columns: statefulConfig,
  };
};

export const shipmentGridChangeOrderBy = (statusViewId, filterViewId, columns) => {
  const statefulConfig = columns.map((c) => ({
    id: c.id,
    index: c.index,
    width: c.width,
    pinned: c.pinned,
    sorted: c.sorted,
  }));
  return {
    type: SHIPMENT_GRID_CHANGE_ORDERBY,
    statusViewId,
    filterViewId,
    columns: statefulConfig,
  };
};

export const shipmentGridChangePage = (newPage, pageSize) => {
  return {
    type: SHIPMENT_GRID_CHANGE_PAGE,
    newPage,
    pageSize,
  };
};

export const manageColumnConfiguration = () => {
  return {
    type: SHIPMENT_GRID_MANAGE_COLUMNS,
  };
};

export const downloadShipmentGridPackingSlips = () => ({
  type: DOWNLOAD_SHIPMENT_GRID_PACKING_SLIPS,
});

export const printShipmentGridPackingSlips = (autoPrint) => ({
  type: PRINT_SHIPMENT_GRID_PACKING_SLIPS,
  autoPrint,
});

export const directPrintShipmentGridPackingSlips = () => ({
  type: DIRECT_PRINT_SHIPMENT_GRID_PACKING_SLIPS,
});

export const downloadShipmentGridLabels = (autoPrint) => ({
  type: DOWNLOAD_SHIPMENT_GRID_LABELS,
  autoPrint,
});

export const printShipmentGridLabels = (autoPrint) => ({
  type: PRINT_SHIPMENT_GRID_LABELS,
  autoPrint,
});

export const directPrintShipmentGridLabels = () => ({
  type: DIRECT_PRINT_SHIPMENT_GRID_LABELS,
});

export const showTheSpinnerOnShipmentsGrid = () => ({
  type: SHIPMENT_GRID_SHOW_SPINNER,
});

export const updateCustomViewGridConfiguration = (customViewColumnConfiguration) => ({
  type: SHIPMENT_GRID_UPDATE_CUSTOM_CONFIGURATION,
  customViewColumnConfiguration,
});

export const patchAmazonShipmentNotifications = (updatedFulfillments) => ({
  type: PATCH_AMAZON_SHIPMENT_NOTIFICATIONS,
  updatedFulfillments,
});
